import { render } from "./send-result.vue?vue&type=template&id=8b7b61d6"
import script from "./send-result.vue?vue&type=script&lang=js"
export * from "./send-result.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__